
<a *ngIf="isBack" (click)="onBack()" class="float-left">
  <i  nz-icon nzType="arrow-left" nzTheme="outline"></i>
  <nz-divider class="float-right mt-sm" nzType="vertical"></nz-divider>
</a>
<div nz-row>
 <h1 nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" class="mt0 inline-block">{{title | translate}}</h1>
<div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" *ngIf="referenceNumber">
    <p class="text-right">
        {{'app.label.title.reference' | translate}}: {{referenceNumber}}&nbsp;
        <a (click)=copyMessage(referenceNumber)>
            <i nz-icon nzTheme="outline" nzTitle="copyReferenceNumber.tooltipText" nz-tooltip nzType="copy"></i>
        </a>
        <span *ngIf="copiedMsg" style="color:green">{{'app.label.copy' | translate}}</span>
        <span *ngIf="status">&nbsp;|&nbsp;Status:<nz-tag>{{status}}</nz-tag></span>
    </p>
</div>   
</div>
<!-- <nz-divider class="mt0 mb-lg"></nz-divider> -->
